<template>
  <div>
    <Control :card="false" :icon="'mdi mdi-view-list'" :title="'Начисления отпускных, больничных листов, компенсации отпуска'" :links="links" :premium="true">

      <template v-slot:left v-if="user.subscribe_type == 'premium'">
        <b-input-group size="sm" prepend="Выберите период">

          <Enums :key="'month' + locale" :type="'enum'" :name="'months'" v-model="additional.month"
                 @change="regAdditionalCharges()"></Enums>

          <Enums :key="'year' + locale" :type="'enum'" :name="'years'" v-model="additional.year"
                 @change="regAdditionalCharges()"></Enums>
        </b-input-group>
      </template>


      <SelectOrg class="mr-sm-1"  :name="'orgs'" :table="'reg_organizations'"
                 :fields="['name']"></SelectOrg>

      <b-form-select class="mr-sm-1" size="sm" v-model="params.worker" @change="regAdditionalCharges()" :options="workers"></b-form-select>

    </Control>

    <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">
      <table class="table table-sm table-bordered table-hover table-14">
        <tbody>

        <tr>
          <th>Тип документа</th>
          <th>Ф.И.О. сотрудника</th>
          <th>ИИН</th>
          <th>Период с</th>
          <th>Период по</th>
          <th>Результат расчета</th>
          <th>Действия</th>
        </tr>

        <template v-for="(item, index) in additional.data.list">
          <tr :key="index">

            <td><Feature :feature="item.feature"></Feature></td>
            <td>{{item.last_name + ' ' + item.first_name + ' ' + item.middle_name}}</td>
            <td>{{item.iin}}</td>
            <td>{{getDate(item.date_from)}}</td>
            <td>{{getDate(item.date_to)}}</td>
            <td>{{item.res_value}}</td>
            <td>

              <PrintAdditionalCharges :id="'printAdditionalChargesBody' + index" :additional="additionalFormatted(item)"></PrintAdditionalCharges>

              <b-button class="mr-sm-1" variant="dark" size="sm" @click="Print('printAdditionalChargesBody' + index, 'portrait')"><span class="mdi mdi-printer"></span>
                Печать
              </b-button>

              <b-button v-if="item.feature != 'merged'" @click="regAdditionalCharges('erase', item.id)" variant="danger" size="sm"><span
                  class="mdi mdi-delete"></span> Удалить
              </b-button>
            </td>

          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <Premium v-else />
  </div>
</template>


<script>
import Control from "@/components/base/ControlPanel";
import SelectOrg from "@/components/base/SelectOrg";
import Enums from "@/components/base/Enums";
import Feature from "@/components/base/Feature";
import {mapGetters} from "vuex";
import PrintAdditionalCharges from "@/components/print/AdditionalCharges";
import Premium from "@/components/base/Premium"

export default {
  name: 'AdditionalCharges',
  components: {
    Control,
    SelectOrg,
    Enums,
    Feature,
    PrintAdditionalCharges,
    Premium
  },
  data: function () {
    return {
      links: [
        {name: 'Калькулятор отпускных/больничных/компенсаций', link: '/salary/additionalcharges/', icon: 'mdi mdi-calculator'},
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      params: {
        worker: 0
      },
      fields: {
        merge: 0
      },
      additional: {
        month: 0,
        year: new Date().getFullYear(),
        data: {
          list: [],
          current: {
          }
        }
      },
    }
  },
  methods: {
    additionalFormatted: function (item) {

      var iface = {
        vacation: {
          title: 'Расчет отпускных',
          icon: 'mdi mdi-tent',
          cardTitle: 'Организация, сотрудник, период отпуска',
          period: 'Период отпуска',
          period2: 'в периоде отпуска',
          count: 'Количество рабочих дней в периоде отпуска',
          amount: 'Общая сумма отпускных'
        },
        additionalvacation: {
          title: 'Расчет дополнительных отпускных',
          icon: 'mdi mdi-tent',
          cardTitle: 'Организация, сотрудник, период дополнительного отпуска',
          period: 'Период отпуска',
          period2: 'в периоде отпуска',
          count: 'Количество рабочих дней в периоде отпуска',
          amount: 'Общая сумма отпускных'
        },
        compensationvacation: {
          title: 'Расчет компенсации при увольнении',
          icon: 'mdi mdi-briefcase',
          cardTitle: 'Организация, сотрудник, период неиспользованного отпуска',
          period: 'Период отпуска',
          period2: 'в периоде неиспользованного отпуска',
          count: 'Количество рабочих дней в периоде отпуска',
          amount: 'Общая сумма отпускных'
        },
        hospital: {
          title: 'Расчет больничных',
          icon: 'mdi mdi-account-injury',
          cardTitle: 'Организация, сотрудник, период больничных',
          period: 'Период больничных',
          period2: 'в периоде больничных',
          count: 'Количество рабочих дней в больничном периоде',
          amount: 'Общая сумма больничных'
        }
      }

      //console.log(JSON.parse(item.res_days))
      //console.log(JSON.parse(item.months))
      //console.log(JSON.parse(item.daysinmonth))

      return {
        feature: item.feature,
        org: this.org,
        worker: {
          last_name: item.last_name,
          first_name: item.first_name,
          middle_name: item.middle_name,
          function: item.function,
        },
        interface: iface[item.feature],
        params: {
          date_from: item.date_from,
          date_to: item.date_to,
          date_employment: item.date_employment,
          sum: item.res_sum,
          daily_sum: item.res_daily_sum,
          days: JSON.parse(item.res_days),
        },
        months: JSON.parse(item.months),
        daysinmonth: JSON.parse(item.res_daysinmonth),
        result: item.res_value
      }

    },
    regAdditionalCharges: function (mode, id) {
      this.$store.commit('wait', {state: true, name: 'Данные по дополнительным начислениям'});
      this.$http
          .post(this.$apiold, {
            task: 'salary-additional-charges',
            mode: mode,
            id: id,
            orgid: this.org.id,
            merge: this.fields.merge,
            data: this.additional,
            params: this.params
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.additional.data = response.data.additional;

            if (response.data.modal) {
              this.$bvModal.show('modal-additional-charges');
            } else {
              this.$bvModal.hide('modal-additional-charges');
            }

            // Сообщения
            this.$store.commit('alert', response.data.messages);
          });
    }
  },
  created() {
    this.regAdditionalCharges();
  },
  computed: {
    ...mapGetters({
      org: 'org',
      workers: 'workersEnum',
      changed: 'changed',
      user: "user"
    })
  },
  watch: {
    additional: {
      handler: function () {
        this.regAdditionalCharges();
      },
      deep: false
    },
    org() {
      this.params.worker = 0;
      this.regAdditionalCharges();
    },
    changed() {
      this.regAdditionalCharges();
      //this.salaryInit();
    },
  }
}
</script>


<style>

</style>
